<template>
  <div id="tabContainer" class="app-main-content">
    <cargo-up-down-resize
      class="app-main-inner section"
      :up-style="{display: 'flex', flexDirection: 'column', paddingBottom: '5px'}"
      :down-style="{display: 'flex', flexDirection: 'column', paddingTop: '5px'}"
      style="height: 100%"
    >
      <template slot="up">
        <div class="section operations">
          <div v-show="cooperateEdit" class="triggers">
            <div v-show="isEdit">
              <el-button no="1" type="primary" :disabled="selectedContainerUsage === null" @click="changeSealHandler">
                {{ $t('SeaExport.SealNoChangeAdfterInspection') }}
              </el-button>
              <el-button no="2" type="primary" :disabled="isAutoLoad" @click="autoLoadHandler">{{
                $t('SeaExport.AutoAllocation')
              }}
              </el-button>
              <el-button no="3" type="primary" :disabled="selectedContainerUsage === null" @click="autoUnloadHandler">
                {{ $t('SeaExport.CleanOutTheLoadingRecord') }}
              </el-button>
              <el-button
                no="4"
                type="danger"
                :disabled="selectedContainerUsage === null"
                @click="deleteContainerHandler"
              >{{ $t('SeaExport.DeleteTheLoadingRecord') }}
              </el-button>
              <el-badge v-if="job.uuid" :is-dot="harbourCheckRead" class="item">
                <el-button v-if="job.uuid" no="6" class="share-button" type="primary" @click="harbourCompare">{{
                  $t('SeaExport.DataComparison')
                }}
                </el-button>
              </el-badge>
              <el-button v-if="job.uuid" no="7" type="primary" size="mini" @click="harbourSync">{{
                $t('SeaExport.SynchronizePortData')
              }}
              </el-button>
              <el-button v-if="job.uuid" no="copyDoorPoint" type="primary" size="mini" @click="copyDoorPointData">{{
                $t('SeaExport.CopyDoorPoint')
              }}
              </el-button>
            </div>
            <div>
              <span>
                {{ $t('SeaExport.CargoQuantityDescription') }}：{{ lbTotalDesc.lblContainerDesc }}&nbsp;&nbsp;&nbsp;
                {{ $t('SeaExport.TotalNumberOfPackages') }}：{{ lbTotalDesc.lbTotalQuantity }}&nbsp;&nbsp;&nbsp;
                {{ $t('SeaExport.TotalWeight') }}：{{ lbTotalDesc.lbTotalWeight }}&nbsp;&nbsp;&nbsp;
                {{ $t('SeaExport.TotalCubage') }}：{{ lbTotalDesc.lbTotalCubage }}&nbsp;&nbsp;&nbsp;
                <el-button
                  v-show="btnshowAWindow && !isEdit"
                  type="primary"
                  @click="showAWindowClickHandler"
                >{{ $t('SeaExport.ViewAssociatedBusiness') }}</el-button>
              </span>
            </div>
          </div>
        </div>
        <cargo-ag-grid
          config-module="130115"
          :grid-options="gridOptions"
          :grid-params.sync="gridParams"
          :column-defs="columnDefs"
          :row-data="containerUsages"
          :wrap-text="true"
          style="width:100%;height:100%"
          @gridReady="params=>gridApi=params.api"
        />
      </template>
      <template slot="down">
        <portData-goods-info
          ref="portDataGoodsInfo"
          :job="job"
          :is-editing="isEditGoods && isEdit"
          :is-or-not-display-so-no="true"
          :is-add-spelling="job.spelling"
          :del-po-items-uuids="delPoItemsUuids"
          :is-uppercase-by-config="isUppercaseByConfig"
          :cooperate-edit="cooperateEdit"
          @change="handleChange"
        />
      </template>
    </cargo-up-down-resize>
    <!-- 查验更改封号弹窗 -->
    <seal-number-change-dialog
      :visible.sync="boxNoDialog.visible"
      :prop-form-data="selectedContainerUsage"
      @sealCloseHandler="sealCloseHandler"
    />

    <!-- 查看关联业务 -->
    <associated-business-dialog
      :visible.sync="associatedBusinessDialog.visible"
      :a-data="associatedBusinessDialog.aData"
      :job="job"
      @refresh="refresh"
    />

    <!-- 港区数据对比弹窗 -->
    <compare-harbour-dialog
      :visible.sync="harbourDialog"
      :data-source="poItems"
      :harbour-source="sourceList"
      :job="job"
      @addContainer="handleAddContainer"
    />
    <!-- 在线客服 -->

    <!-- 抄录门点拖柜数据 -->
    <tab-container-record-link-dialog
      :visible.sync="containerRecordDialog.visible"
      :job-uuid="job.uuid"
      @selectTruckingRecordHandler="selectTruckingRecordHandler"
    />

  </div>
</template>

<script>
import URL from '@/api/urlTranslator'

import { Job } from '@/class/model/booking/Job'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as NumberUtils from '@/utils/NumberUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import * as EQSize from '@/class/cargo/model/parameters/EQSize'
import SealNumberChangeDialog from '@/components/Cargo/Job/sealNumberChangeDialog'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import { DataPushCompareUtils } from '@/class/cargo/model/utils/DataPushCompareUtils'
import ContainerNoHelper from '@/utils/containerNoHelper'
import StrUtils from '@/utils/StrUtils'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { TabError } from '@/utils/class/TabError'
import { deepClone, sortByMultiField } from '@/utils'
import AssociatedBusinessDialog from '@/components/Cargo/Job/associatedBusinessDialog'
import {
  queryAssociatedBusiness,
  importExcelData,
  updateRead
} from '@/api/seaExport/containerUsage'
import lodash from 'lodash'
import { formatNumberToThousands } from '@/utils'
import { roundHalfUp } from '@/utils/NumberUtils'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import compareHarbourDialog from '@/components/Cargo/Job/compareHarbourDialog'
import portDataGoodsInfo from './portDataGoodsInfo'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoUpDownResize from '@/components/Cargo/Common/cargoUpDownResize'
import { PortDataCompareUtils } from '@/class/cargo/model/utils/PortDataCompareUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import CargoAgGridDateTimeEditor from '@/components/Cargo/Common/CargoAgGridDateTimeEditor'
import TabContainerRecordLinkDialog from '@/components/Cargo/Job/tabContainerRecordLinkDialog'
import { IntegratedJob } from '@/class/model/booking/IntegratedJob'

export default {
  name: 'TabContainer',
  components: {
    CargoUpDownResize,
    AssociatedBusinessDialog,
    SealNumberChangeDialog,
    compareHarbourDialog,
    portDataGoodsInfo,
    TabContainerRecordLinkDialog
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    viewSource: { // 页面请求发起方
      type: String,
      required: false
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      URL,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        frameworkComponents: {
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridCommonTextareaEditor,
          CargoAgGridCommonInputEditor,
          CargoAgGridDateTimeEditor
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onCellFocused(event)
        },
        onRowClicked: this.itemClickHandler,
        onRowDragEnd: this.onRowDragEnd
      },
      gridApi: null,
      boxNoDialog: {
        visible: false
      },
      associatedBusinessDialog: {
        visible: false,
        aData: {}
      },
      lbTotalDesc: { // 货物描述
        lblContainerDesc: '',
        lbTotalQuantity: '',
        lbTotalWeight: '',
        lbTotalCubage: ''
      },
      job: new Job().fillDefaultValue().getData(),
      containerUsages: [], // 装箱列表数据List
      dgContainerEditable: false, // 列表是否允许编辑
      selectedContainerUsage: null,
      btnshowAWindow: false,
      isUpdateCargoDoc: false, // 修改了件毛体则为true,作用是同步了件毛体信息需要参与入库修改
      isTabBasic: true, // CARGO-7908 (cargo 中在bookingworkspace 中设置的是true)
      isAutoLoad: false,
      openPortDataService: 1, // 港区推送状态 1）不在服务范围内，且没开通服务；2）在服务范围内，且没开通服务；3）不在服务范围内，且开通服务；4）在数据服务范围内，且开通服务
      harbourList: [], // 港区推送数据,
      mergeHarbourList: [], // 港区数据合并(即合并货物信息)
      harbourCheckRead: false, // 校验港区数据推送是否已读
      harbourDialog: false, // 数据对比弹框
      sourceList: [], // 对比数据源
      manifestGoods: {},
      isEditGoods: false, // 控制货物信息
      poItems: [],
      selection: [],
      delPoItemsUuids: [],
      containerRecordDialog: {// 抄录门点拖柜弹窗
        visible: false
      },
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      let printHblZbLock = false
      if (this.job.cargoDoc) {
        for (const doc of this.job.cargoDoc) {
          if (doc.docType === CargoDocConsts.HBL) {
            printHblZbLock = (doc.state === 2 && Number(this.config.get('HBLPrintLockTab')) === 1)
          }
        }
      }
      return this.action !== 'look' && !printHblZbLock
    },
    user() {
      return this.context.user || {}
    },
    columnDefs() {
      const defs =
        [
          {
            headerName: '',
            colId: 'serialNo',
            field: '',
            width: 60,
            rowDrag: this.dgContainerEditable && this.isEdit,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false,
            lockVisible: true,
            wrapText: false // 去除因拖拽而导致的行自动撑高
          },
          {
            headerName: this.$t('SeaExport.PortInformationVerification'),
            colId: 'confirmed',
            field: 'confirmed',
            width: 100,
            valueFormatter: (params) => {
              if (params.value) {
                let text = ''
                switch (params.value) {
                  case 0:
                    text = this.$t('SeaExport.NotVerified')
                    break
                  case 10:
                    text = this.$t('SeaExport.SystemVerification')
                    break
                  case 11:
                    text = this.$t('SeaExport.ManualVerification')
                    break
                  case 12:
                    text = this.$t('SeaExport.ManualVerification')
                    break
                  case 13:
                    text = this.$t('SeaExport.ManualVerification')
                    break
                  default:
                    text = this.$t('SeaExport.ToBeConfirmed2')
                    break
                }
                return text
              } else {
                return this.$t('SeaExport.NotVerified')
              }
            }
          },
          {
            headerName: this.$t('SeaExport.ContainerSize'),
            colId: 'eqSize',
            field: 'eqSize',
            width: 100,
            cellStyle: (params) => {
              return this.containerPushDataStyleFunction(params, 'eqSize')
            },
            valueFormatter: (params) => {
              return this.subClassLabelFunction(params.data, 'eqSize')
            }
          },
          {
            headerName: this.$t('SeaExport.ContainerType'),
            colId: 'eqType',
            field: 'eqType',
            width: 100,
            cellStyle: (params) => {
              return this.containerPushDataStyleFunction(params, 'eqType')
            },
            valueFormatter: (params) => {
              return this.subClassLabelFunction(params.data, 'eqType')
            }
          },
          {
            headerName: this.$t('SeaExport.ContainerNo'),
            colId: 'containerNo',
            field: 'containerNo',
            width: 100,
            cellStyle: (params) => {
              return this.containerNbrStyleFunction(params)
            },
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: p => {
              const { newValue, oldValue, node, colDef } = p
              if (newValue && newValue.length > 11) {
                this.$message.warning(this.$t('SeaExport.ContainerNoOutOfRange'))
                node.setDataValue(colDef.colId, oldValue)
                return
              }
              const check = JobUtils.checkCNoHandler(this.job, oldValue)
              if (check) {
                node.setDataValue(colDef.colId, oldValue)
                return
              }
              this.onCellChange(p)
            }
          },
          {
            headerName: this.$t('SeaExport.ContainerWeight'),
            colId: 'containerWeight',
            field: 'containerWeight',
            width: 100,
            cellStyle: (params) => {
              return ContainerUtil.containerPushDataStyleFunction2(params, 'containerWeight')
            },
            valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3
              }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.SealNo'),
            colId: 'sealNo',
            field: 'sealNo',
            width: 100,
            cellStyle: (params) => {
              return this.sealNoStyleFunction(params)
            },
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.Quantity'),
            colId: 'quantity',
            field: 'quantity',
            width: 100,
            cellStyle: (params) => {
              return this.containerPushDataStyleFunction(params, 'quantity')
            },
            valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 0, true)),
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 0
              },
              multiplePaste: { isNumber: true, precision: 0 }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.GrossWeight'),
            colId: 'weight',
            field: 'weight',
            width: 100,
            cellStyle: (params) => {
              return this.containerPushDataStyleFunction(params, 'weight')
            },
            valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3
              },
              multiplePaste: { isNumber: true, precision: 3 }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.Cubage'),
            colId: 'cubage',
            field: 'cubage',
            width: 100,
            cellStyle: (params) => {
              return this.containerPushDataStyleFunction(params, 'cubage')
            },
            valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3
              },
              multiplePaste: { isNumber: true, precision: 3 }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
            colId: 'cargoName',
            field: 'cargoName',
            width: 120,
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonTextareaEditor',
            cellEditorParams: {
              autoUppercase: this.isUppercaseByConfig
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.Marks'),
            colId: 'mark',
            field: 'mark',
            width: 100,
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonTextareaEditor',
            cellEditorParams: {
              autoUppercase: this.isUppercaseByConfig
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.Soc'),
            colId: 'soc',
            field: 'soc',
            width: 100,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: this.dgContainerEditable && this.isEdit,
              tag: 'el-checkbox',
              valueChanged: p => {
                this.onCellChange(p)
              }
            }
          },
          {
            headerName: this.$t('SeaExport.Inspection'),
            colId: 'inSpected',
            field: 'inSpected',
            width: 100,
            valueFormatter: (params) => {
              return this.subInSpectedLabelFunc(params.data)
            }
          },
          {
            headerName: 'HSCODE',
            colId: 'hsCode',
            field: 'hsCode',
            width: 120,
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              field: 'hsCode'
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.ApproachDate'),
            colId: 'approachDate',
            field: 'approachDate',
            width: 120,
            hide: true,
            editable: this.isEdit,
            cellEditor: 'CargoAgGridDateTimeEditor',
            cellEditorParams: {
              props: {
                type: 'datetime',
                format: 'yyyy-MM-dd HH:mm:ss',
                valueFormat: 'yyyy-MM-dd HH:mm:ss',
                editable: false
              }
            },
            onCellValueChanged: p => this.onCellChange(p),
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          },
          {
            // 出场时间
            headerName: this.$t('SeaExport.PlayDate'),
            colId: 'playDate',
            field: 'playDate',
            width: 120,
            hide: true,
            editable: this.isEdit,
            cellEditor: 'CargoAgGridDateTimeEditor',
            cellEditorParams: {
              props: {
                type: 'datetime',
                format: 'yyyy-MM-dd HH:mm:ss',
                valueFormat: 'yyyy-MM-dd HH:mm:ss',
                editable: false
              }
            },
            onCellValueChanged: p => this.onCellChange(p),
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.LoadingPort'),
            colId: 'loadingPort',
            field: 'loadingPort',
            hide: true,
            width: 100
          },
          {
            headerName: this.$t('SeaExport.PortOfDestination'),
            colId: 'destinationPort',
            field: 'destinationPort',
            hide: true,
            width: 100,
            editable: this.isEdit,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                selectType: TYPE_NAMES.basic_data_Seaport,
                filterable: true,
                tagValue: 'code',
                customLabel: (item) => this.language === 'zh' ? `${item.chineseName}[${item.name}]` : `${item.name}[${item.chineseName}]`,
                showCustomLabelInOption: true
              }
            },
            onCellValueChanged: p => this.onCellChange(p),
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            }
          },
          {
            headerName: this.$t('SeaExport.TheArrivalOfPacketsSent'),
            colId: 'transportMessageDate',
            field: 'transportMessageDate',
            hide: true,
            width: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            // 海关放行信息
            headerName: this.$t('SeaExport.CustomsClearanceInfo'),
            colId: 'customReleaseDate',
            field: 'customReleaseDate',
            hide: true,
            width: 120,
            valueFormatter: (params) => {
              if (params.data.customReleaseState) {
                return params.data.customReleaseState === 'Y' ? `${params.data.customReleaseState}(${params.data.customReleaseDate})` : params.data.customReleaseState
              } else {
                return params.data.customReleaseDate
              }
            }
          },
          {
            // 码头放行信息
            headerName: this.$t('SeaExport.WharfReleaseInfo'),
            colId: 'wharfReleaseDate',
            field: 'wharfReleaseDate',
            hide: true,
            width: 120,
            valueFormatter: (params) => {
              if (params.data.wharfReleaseDate) {
                return params.data.wharfReleaseState ? `${params.data.wharfReleaseState}(${params.data.wharfReleaseDate})` : params.data.wharfReleaseDate
              } else {
                return params.data.wharfReleaseState ? params.data.wharfReleaseState : ''
              }
            }
          },
          {
            headerName: this.$t('SeaExport.ContainerAscription'),
            colId: 'containerAscription',
            field: 'containerAscription',
            width: 120,
            valueFormatter: (params) => {
              const options = [...SeaExportConstants.CONTAINER_ASCRIPTION_TYPE]
              const curOption = options.find(option => option.code === params.value)
              if (curOption) {
                return curOption.chineseName
              }
              return ''
            },
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                staticOptions: [...SeaExportConstants.CONTAINER_ASCRIPTION_TYPE],
                tagValue: 'code',
                tagName: 'chineseName'
              }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.PlateNumber'),
            colId: 'plateNumber',
            field: 'plateNumber',
            hide: true,
            width: 120,
            editable: this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.plateApproachDate'),
            colId: 'plateApproachDate',
            field: 'plateApproachDate',
            hide: true,
            width: 120,
            editable: this.isEdit,
            cellEditor: 'CargoAgGridDateTimeEditor',
            cellEditorParams: {
              props: {
                type: 'datetime',
                format: 'yyyy-MM-dd HH:mm:ss',
                valueFormat: 'yyyy-MM-dd HH:mm:ss',
                editable: false
              }
            },
            onCellValueChanged: p => this.onCellChange(p),
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.platePlayDate'),
            colId: 'platePlayDate',
            field: 'platePlayDate',
            hide: true,
            width: 120,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            editable: this.isEdit,
            cellEditor: 'CargoAgGridDateTimeEditor',
            cellEditorParams: {
              props: {
                type: 'datetime',
                format: 'yyyy-MM-dd HH:mm:ss',
                valueFormat: 'yyyy-MM-dd HH:mm:ss',
                editable: false
              }
            },
            onCellValueChanged: p => this.onCellChange(p),
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.Remarks'),
            colId: 'remark',
            field: 'remark',
            width: 100,
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            // 码头配载
            headerName: this.$t('SeaExport.WharfStowage'),
            colId: 'wharfStowage',
            field: 'wharfStowage',
            valueFormatter: (params) => {
              if (params.data.wharfStowage) {
                return params.data.wharfStowageState ? `${params.data.wharfStowageState}(${params.data.wharfStowage})` : params.data.wharfStowage
              } else {
                return params.data.wharfStowageState ? params.data.wharfStowageState : ''
              }
            }
          },
          {
            headerName: this.$t('SeaExport.Package'),
            colId: 'packing',
            field: 'packing',
            width: 100,
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                selectType: TYPE_NAMES.basic_data_Packing,
                filterable: true,
                tagValue: 'code',
                customLabel: (item) => this.language === 'zh' ? `${item.chineseName}[${item.name}]` : `${item.name}[${item.chineseName}]`,
                showCustomLabelInOption: true
              }
            },
            valueFormatter: params => {
              return ColumnUtils.packingCodeLabelFun(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.DestinationDeliveryTime'),
            field: 'destinationDeliveryTime',
            colId: 'destinationDeliveryTime',
            width: 150,
            valueFormatter: (params) => {
              return this.destinationDisplayFunction(params, 'destinationDeliveryTime')
            },
            editable: this.isEdit,
            cellEditor: 'CargoAgGridDateTimeEditor',
            cellEditorParams: {
              props: {
                type: 'date',
                format: 'yyyy-MM-dd',
                valueFormat: 'yyyy-MM-dd',
                editable: false
              }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.DestinationReturnTime'),
            field: 'destinationReturnTime',
            colId: 'destinationReturnTime',
            width: 150,
            valueFormatter: (params) => {
              return params.data.container ? params.data.container.destinationReturnTime : ''
            },
            editable: this.isEdit,
            cellEditor: 'CargoAgGridDateTimeEditor',
            cellEditorParams: {
              props: {
                type: 'date',
                format: 'yyyy-MM-dd',
                valueFormat: 'yyyy-MM-dd',
                editable: false
              }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.BoxController'),
            colId: 'boxController',
            field: 'boxController',
            hide: true,
            width: 100,
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: p => this.onCellChange(p)
          }
        ]
      return defs
    },
    config() {
      return this.context.config
    },
    language() {
      return this.$store.getters.language
    }
  },
  created() {
    // this.context.loading = true
    // await this.context.prepareData()
  },
  methods: {
    async onShow(row, isRefresh) {
      this.job = row
      this.mergeHarbourList = []
      this.isAutoLoad = false
      await this.jobChanged()
      this.btnshowAWindow = (StrUtils.isEmpty(this.job.relatedJob) && !StrUtils.isEmpty(this.job.trustFromJob)) ||
        (StrUtils.isEmpty(this.job.trustFromJob) && !StrUtils.isEmpty(this.job.relatedJob))
      this.isUppercaseByConfig = Number(this.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
      this.initCompare()
    },
    endTabHandler() {
      this.fillModel()
    },
    async jobChanged() {
      if (!this.job) return

      const job = new IntegratedJob(this.job)
      await Promise.all([
        job.getSeaEQ(),
        job.getContainerUsages(),
        job.getContainers(),
        job.getPoItems()
      ])
      this.poItems = this.job.poItems && this.job.poItems.length > 0 ? this.job.poItems.sort((a, b) => {
        return a.sequenceNo - b.sequenceNo
      }) : []

      await this.jobLoadResultHandler()

      // 组装 containers.containerUsage  同 job.containerUsages 指向同一usage
      await ContainerUtil.buildContainerUsages(this.job)

      const containerUsages = this.job.containerUsages.sort((a, b) => {
        return a.serialNo - b.serialNo
      })
      // containerUsages.forEach((item, index) => {
      //   item.serialNo = index
      // })
      this.containerUsages = containerUsages

      this.refreshContainerWeight()
      this.refreshTotal()

      // CARGO-10331 【提单制作】参数HBLZBPrintLockTab未生效，HBL已锁定仍能编辑
      this.dgContainerEditable = this.isEdit

      // 港区数据同步对比服务
      if (this.gridApi) {
        this.gridApi.clearFocusedCell()
        this.gridApi.refreshCells({ force: true })
        this.isEditGoods = false
        this.manifestGoods = {}
      }
      this.manifestGoods = {}
      this.$refs.portDataGoodsInfo.init({})
      PortDataCompareUtils.initContainerPoItems(this.containerUsages, this.poItems)
    },

    async getSubmitData() {
      this.validate()
      this.fillModel()
      // 装箱件毛体 可能是从基本页签同步而来 没有触发cellChange 方法，同步箱子上的件毛体
      for (const usage of this.containerUsages) {
        if (usage.container) {
          usage.container.quantity = usage.quantity
          usage.container.weight = usage.weight ? usage.weight : 0
          usage.container.cubage = usage.cubage
        }
        if (usage.poItems === '') {
          usage.poItems = []
        }
      }
      if (this.job.containers) {
        for (const container of this.job.containers) {
          if (container.containerUsage) {
            for (const item of container.containerUsage) {
              // 同步箱封号
              if (item.sealNo && item.sealNo !== container.sealNo) {
                container.sealNo = item.sealNo
                container.isDirty = true
              }
              container.plateNumber = item.plateNumber
              if (item.poItems === '') {
                item.poItems = []
              }
            }
          }
        }
      }
      const job = { ...this.job }
      const delContainerUuids = this.job.delContainerUuids || []
      const delContainerUsageUuids = this.job.delContainerUsageUuids || []
      const result = {
        job, // 未打开过时 件毛体同步数据需要保存
        delPoItemsUuids: this.delPoItemsUuids,
        containerUsages: this.containerUsages.filter(p => !delContainerUsageUuids.includes(p.uuid)),
        // 设置了临时uuid addContainer_，这个地方移除被删除的临时箱子
        containers: this.job.containers.filter(p => !delContainerUuids.includes(p.uuid)),
        delContainerUuids: delContainerUuids // 删除的箱子uuid
      }
      if (this.job.delseaEQUuids && this.job.delseaEQUuids.length > 0) {
        result.delseaEQUuids = [...job.delseaEQUuids]
      }
      // 修改件毛体
      if (this.isUpdateCargoDoc) {
        result.seaCargoDoc = [...job.seaCargoDoc]
      }
      if (this.job.seaEQ && this.job.seaEQ.length > 0) {
        result['seaEQ'] = this.job.seaEQ
      }
      if (this.selection && this.selection.length > 0) {
        result['confirmedVOS'] = this.selection
      }
      return result
    },
    fillModel() {
      // CARGO-7908
      const expression = Number(this.config.get('ContainerUpdateJobQCW'))
      if (expression === 3 && this.isTabBasic) {
        ContainerUtil.refContainerUsageQwc(this.job, 3)
      }
    },
    /**
     * 验证
     */
    validate() {
      if (!this.job || !this.job.containerUsages || !this.isEdit) {
        return true
      }
      const msg = ContainerUtil.validateContainerUsage(this.job)
      if (msg) {
        throw new TabError(msg, 'tabContainer')
      }
      if ((!this.job.seaEQ || this.job.seaEQ.length === 0) && this.job.containerLoadType === 'TT') {
        this.$emit('clearSeaEqList', this.job)
        throw new TabError(this.$t('Message.EQSizeCannotBeNull2'), 'tabGatheringTrailerBase')
      }
      return true
    },
    async jobLoadResultHandler() {
      // 根据箱型初始化箱子(待审核的时候不允许看到装箱信息)
      if (this.job.jobState > SystemConstants.PENDING) {
        await ContainerUtil.autoJustContainerUsages(this.job, this.action, false)
      }

      // 避免 JSON 对象的循环引用  sortByMultiField 报错 ，后端排序
      // this.job.containerUsages = this.sortByOrder(this.job.containerUsages)

      this.selectedContainerUsage = null

      //  需要先 关联 container 与 containerUsage之后 调用
      // await this.refreshContainerWeight()

      this.checkCargoDocState()
      // this.refreshTotal()
    },
    // 按照指定字段排序
    sortByOrder(categoryArray) {
      if (categoryArray == null || categoryArray.length === 0) {
        return null
      } else {
        categoryArray = sortByMultiField(categoryArray, ['dateCreated'], false)
      }
      return categoryArray
    },
    refreshContainerWeight() {
      for (const usage of this.containerUsages) {
        if (usage.container) {
          // 列显示 箱子相关信息 移至 usage
          const eqSize = EQSize.getEQSizeByCode(usage.container.eqSize)
          usage.eqSize = eqSize === null ? '' : eqSize.code
          usage.eqType = usage.container.eqType
          usage.containerNo = usage.container.containerNo
          usage.containerWeight = usage.container.containerWeight
          usage.sealNo = usage.container.sealNo
          usage.remark = usage.container.remark

          usage.approachDate = usage.container.approachDate
          usage.playDate = usage.container.playDate
          usage.loadingPort = usage.container.loadingPort
          usage.dischargingPort = usage.container.dischargingPort
          usage.destinationPort = usage.container.destinationPort
          usage.transportMessageDate = usage.container.transportMessageDate
          usage.wharfReleaseDate = usage.container.wharfReleaseDate
          usage.customReleaseDate = usage.container.customReleaseDate
          usage.containerAscription = usage.container.containerAscription
          usage.plateNumber = usage.container.plateNumber
          usage.plateApproachDate = usage.container.plateApproachDate
          usage.platePlayDate = usage.container.platePlayDate
          usage.boxController = usage.container.boxController
          usage.carNumber = usage.container.carNumber
        }
      }
    },
    checkCargoDocState() {
      if (this.isEdit) {
        let unlock = true
        for (const doc of this.job.cargoDoc) {
          if (doc.docType.substr(0, 3) === 'HBL' && doc.state > 1) {
            unlock = false
            break
          }
        }
        this.dgContainerEditable = unlock
      }
    },
    refreshTotal() {
      let quantity = 0
      let weight = 0
      let cubage = 0

      for (const usage of this.job.containerUsages) {
        if (usage.deleted) {
          continue
        }
        quantity += Number(usage.quantity) || 0
        if (!isNaN(usage.weight)) {
          weight += Number(usage.weight)
        }
        if (!isNaN(usage.cubage)) {
          cubage += Number(usage.cubage)
        }
      }
      this.lbTotalDesc.lbTotalQuantity = NumberUtils.formatNumber(quantity, 0)
      this.lbTotalDesc.lbTotalWeight = NumberUtils.formatNumber(weight, 3)
      this.lbTotalDesc.lbTotalCubage = NumberUtils.formatNumber(cubage, 3)
      this.lbTotalDesc.lblContainerDesc = ContainerUtil.getContainerDesc(this.job)
    },
    containerNbrStyleFunction(params) {
      const usage = params.data
      if (usage.container) {
        if (usage && !ContainerNoHelper.checkContainerNo(params.value)) {
          return { color: '#F56C6C' }
        }
        if (DataPushCompareUtils.comparePushData(this.$t('SeaExport.ContainerNo'), params.value, usage.container.uuid)) {
          return { color: '#1F75D5' }
        }
      }
      return { color: '' }
      // this.containerPushDataStyleFunction(params, 'ContainerNo')
    },
    sealNoStyleFunction(params) {
      const usage = params.data
      if (usage.container) {
        if (usage.isReSealed) {
          return { color: '#F56C6C' }
        }
        if (DataPushCompareUtils.comparePushData(this.$t('SeaExport.SealNo'), params.value, usage.container.uuid)) {
          return { color: '#1F75D5' }
        }
      }
      return { color: '' }
    },
    containerAscriptionFunc(val) {
      for (const item of SeaExportConstants.CONTAINER_ASCRIPTION_TYPE) {
        if (item.code === val) {
          return item.chineseName
        }
      }
    },
    subInSpectedLabelFunc(data) {
      if (data && data.container) {
        const isInSpected = data.container.inSpected
        return isInSpected ? this.$t('Message.Yes') : this.$t('Message.No')
      }
      return ''
    },
    subClassLabelFunction(data, fieldName) {
      if (fieldName === 'eqSize') {
        const eqSize = data.container ? EQSize.getEQSizeByCode(data.container[fieldName]) : null
        return eqSize === null ? '' : eqSize.name
      } else {
        if (!data.container) return ''
        return data.container[fieldName] || ''
      }
    },
    // 行选择事件
    itemClickHandler(event) {
      if (!event.data) {
        return
      }
      this.selectedContainerUsage = event.data
      // this.manifestGoods = event.data
      this.$refs.portDataGoodsInfo.init(event.data)
      this.isEditGoods = true
    },
    onCellFocused(event) {
      if (this.gridOptions.api && event.column) {
        this.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedContainerUsage = node.data
          }
        })
      }
    },
    // 列编辑修改事件 (gridEditSaveHandler)
    onCellChange(params) {
      const _job = this.job
      const usage = params.data
      if (!usage) {
        return
      }
      // 列编辑时 usage.container 没了，所以加了如下方法重新赋值
      if (usage && !usage.container && this.job.containers && this.job.containers.length > 0) {
        for (const container of this.job.containers) {
          if (StrUtils.isEmpty(container.uuid)) continue
          if (usage.containerUuid === container.uuid) {
            usage.container = container
          }
          if (container.containerUsage) {
            for (let oldUsage of container.containerUsage) {
              if (usage.uuid === oldUsage.uuid) {
                oldUsage = usage
              }
            }
          }
        }
      }
      usage.container.isDirty = true
      const key = params.field || params.colDef.colId
      switch (key) {
        case 'containerNo':
          console.log('containerNo')
          usage.container.containerNo = usage.containerNo
          // 同步poItems ContainerNo
          this.syncPoItemsContainerNo(usage)
          break
        case 'sealNo':
          usage.container.sealNo = usage.sealNo
          break
        case 'containerWeight':
          // 箱重处理四舍五入 入库（控件只做了前端显示处理）
          if (usage.containerWeight) {
            usage.containerWeight = roundHalfUp(usage.containerWeight, 3)
            usage.container.containerWeight = usage.containerWeight
          } else {
            usage.containerWeight = 0
            usage.container.containerWeight = usage.containerWeight
          }
          this.syncVgmInfo(usage.container)
          break
        case 'containerAscription':
          usage.container.containerAscription = usage.containerAscription
          break
        case 'cargoName':
          usage.container.cargoName = usage.cargoName
          break
        case 'remark':
          usage.container.remark = usage.remark
          break
        case 'boxController':
          usage.container.boxController = usage.boxController
          break
        case 'mark':
          usage.container.mark = usage.mark
          break
        case 'quantity' :
          // 用删除的方式 内容是空 保存null 会报错
          if (!usage.quantity) {
            usage.quantity = 0
          }
          // h5 不需要 quantityChange(usage, event);
          if (_job && _job.lob === SystemConstants.SE.code) {
            this.updateJobActualQWC()
            this.refreshQWC()
            if (usage.container) {
              usage.container.quantity = usage.quantity
            }
          }
          usage.isDirty = true
          break
        case 'weight' :
          if (!usage.weight) {
            usage.weight = 0
          }
          // h5 不需要  weightChange(usage, event);
          if (_job && _job.lob === SystemConstants.SE.code) {
            this.updateJobActualQWC()
            this.refreshQWC()
            if (usage.container) {
              usage.container.weight = usage.weight
            }
          }
          this.syncVgmInfo(usage.container)
          break
        case 'cubage' :
          if (!usage.cubage) {
            usage.cubage = 0
          }
          // h5 不需要  cubageChange(usage, event);
          if (_job && _job.lob === SystemConstants.SE.code) {
            this.updateJobActualQWC()
            this.refreshQWC()
            if (usage.container) {
              usage.container.cubage = usage.cubage
            }
          }
          break
        case 'destinationDeliveryTime':
          usage.container.destinationDeliveryTime = usage.destinationDeliveryTime
          break
        case 'destinationReturnTime':
          usage.container.destinationReturnTime = usage.destinationReturnTime
          break
        case 'approachDate':
          usage.container.approachDate = usage.approachDate
          break
        case 'playDate':
          usage.container.playDate = usage.playDate
          break
        case 'plateNumber':
          usage.container.plateNumber = usage.plateNumber
          break
        case 'plateApproachDate':
          usage.container.plateApproachDate = usage.plateApproachDate
          break
        case 'platePlayDate':
          usage.container.platePlayDate = usage.platePlayDate
          break
        case 'destinationPort':
          usage.container.destinationPort = usage.destinationPort
          break
        default :
          break
      }
      if (this.gridApi) this.gridApi.refreshCells({ force: true })
    },
    // CARGO-8570 海出详情VGM页面，VGM重量自动计算
    syncVgmInfo(container) {
      ContainerUtil.refreshVgmWeight(container)
    },
    /**
     * 计算件毛体总数
     */
    refreshQWC() {
      let quantity = 0
      let weight = 0
      let cubage = 0
      for (const usage of this.job.containerUsages) {
        quantity += Number(usage.quantity) || 0
        if (!isNaN(usage.weight)) {
          weight += Number(usage.weight)
        }
        if (!isNaN(usage.cubage)) {
          cubage += Number(usage.cubage)
        }
      }
      this.lbTotalDesc.lbTotalQuantity = NumberUtils.formatNumber(quantity, 0)
      this.lbTotalDesc.lbTotalWeight = NumberUtils.formatNumber(weight, 3)
      this.lbTotalDesc.lbTotalCubage = NumberUtils.formatNumber(cubage, 3)
    },
    updateJobActualQWC() {
      this.isUpdateCargoDoc = true
      ContainerUtil.refContainerUsageQwc(this.job, 1)
    },
    // 查验更改封号
    changeSealHandler() {
      if (!this.selectedContainerUsage) {
        return
      }
      this.boxNoDialog.visible = true
    },
    // 查验更改封号 回调事件
    sealCloseHandler(data) {
      const usage = this.selectedContainerUsage
      if (usage.container.sealNo !== data.sealNo) {
        usage.isReSealed = true
        usage.container.inSpected = true
      }
      usage.container.sealNo = data.sealNo
      usage.container.containerNo = data.containerNo
      usage.container.remark = data.remark

      usage.container.isDirty = true

      // 箱子信息列字段移至 usage
      usage.sealNo = data.sealNo
      usage.containerNo = data.containerNo
      usage.remark = data.remark
      if (this.gridApi) {
        this.gridApi.refreshCells({ force: true })
      }
    },
    // 自动装箱
    autoLoadHandler() {
      // 当前小票下的箱子只要有过对比，就进行弹窗提醒
      if (this.job.containers.length > 0) {
        if (this.job.containers.find(item => item.confirmed > 0)) {
          this.$confirm(this.$t('Integrated.YourWeightAndVolumeTo'), this.$t('Integrated.Tip'), {
            confirmButtonText: this.$t('Integrated.GotIt'),
            showCancelButton: false,
            type: 'info'
          })
        }
      }
      ContainerUtil.autoLoadContainerUsage(this.job)
      // 设置更改标识
      for (const ctnr of this.job.containers) {
        ctnr.isDirty = true
      }
      this.gridApi.setRowData(this.job.containerUsages)
      this.refreshTotal()
    },
    // 清空装箱记录
    autoUnloadHandler() {
      const usage = this.selectedContainerUsage
      if (usage) {
        usage.container.containerNo = ''
        usage.container.sealNo = ''
        usage.weight = 0
        usage.quantity = 0
        usage.cubage = 0
        usage.hsCode = ''
        usage.container.cargoName = ''
        usage.cargoName = ''

        // 箱子信息列字段移至 usage
        usage.containerNo = ''
        usage.sealNo = ''

        usage.container.isDirty = true
        usage.isDirty = true
        usage.boxController = ''
        usage.carNumber = ''
        usage.container.boxController = ''
        usage.container.carNumber = ''
      }
      this.gridOptions.api.applyTransaction({ update: [usage] })
      this.refreshTotal()
    },
    // 删除装箱记录
    deleteContainerHandler() {
      const items = this.gridApi.getSelectedRows()
      if (items.length === 0) {
        return
      }
      for (const usage of items) {
        //  记录删除的 箱子uuid  此处记录到job 字段属性上
        if (!StrUtils.isEmpty(usage.uuid)) {
          if (!this.job.delContainerUuids) {
            this.job.delContainerUuids = []
          }
          this.job.delContainerUuids.push(usage.containerUuid)
        }
        const poItems = usage.poItems
        if (poItems) {
          poItems.forEach(item => {
            if (!StrUtils.isEmpty(item.uuid)) {
              this.delPoItemsUuids.push(item.uuid)
            }
          })
        }
        const index = this.containerUsages.findIndex(p => p === usage)
        this.containerUsages.splice(index, 1)
        // 这里刷新下SeaEQ
        this.refreshSeaEqForDelete(usage.eqSize, usage.eqType)
      }
      this.$refs.portDataGoodsInfo.clear()
      this.manifestGoods = {}
      this.isEditGoods = false
      this.refreshTotal()
      this.gridApi.clearFocusedCell()
    },
    refreshSeaEqForDelete(size, type) {
      const seaEqList = []
      if (!this.job.delseaEQUuids) {
        this.job.delseaEQUuids = []
      }
      for (const seaEq of this.job.seaEQ) {
        if (seaEq.eqSize === size && seaEq.eqType === type) {
          if (seaEq.eqQuantity > 1) {
            seaEq.eqQuantity = seaEq.eqQuantity - 1
            seaEqList.push(seaEq)
          } else if (seaEq.eqQuantity === 1 && seaEq.uuid) {
            // 只有一个就删了
            this.job.delseaEQUuids.push(seaEq.uuid)
          }
        } else {
          seaEqList.push(seaEq)
        }
      }
      this.job.seaEQ = seaEqList
    },
    // 查看关联业务
    showAWindowClickHandler() {
      if ((!this.job.relatedJob && this.job.trustFromJob) || this.job.relatedJob && !this.job.trustFromJob) {
        const params =
          {
            trustFromJobNo: this.job.trustFromJob,
            relatedJobNo: this.job.relatedJob
          }
        // 调用api
        queryAssociatedBusiness(params).then(res => {
          this.queryWindowResultHandler(res.data)
        })
      }
    },
    queryWindowResultHandler(data) {
      if (!data) return
      this.associatedBusinessDialog.aData = data
      this.associatedBusinessDialog.visible = true
    },
    // 刷新
    async refresh() {
      if (this.job && !StrUtils.isEmpty(this.job.uuid)) {
        const job = new IntegratedJob(this.job)
        job.seaEQ = ''
        job.containers = ''
        job.containerUsages = ''
        await Promise.all([
          job.getSeaEQ(),
          job.getContainerUsages(),
          job.getContainers()
        ])
        await this.jobChanged()
      }
    },
    // 模板下载
    downTemplateBtn_clickHandler() {
      const fileName = 'ContainerUsageImportTemplate.xls'
      const folderName = 'booking'
      ExportUtils.downloadTemplateFile(fileName, folderName)
    },
    beforeUploadUsage(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    // excel导入
    importExcelEventHandler(item) {
      const usages = lodash.cloneDeep(this.job.containerUsages)
      // 避免循环引用
      for (const usage of usages) {
        delete usage.container.containerUsage
      }

      const jobObj = { job: { lob: this.job.lob }, seaEQ: this.job.seaEQ, containerUsages: usages }
      const params = {
        file: item.file,
        job: JSON.stringify(jobObj),
        jobUuid: this.job.uuid,
        jobNo: this.job.jobNo
      }
      importExcelData(params).then(response => {
        if (response.data == null || response.data === '') {
          this.$message.warning(this.$t('SeaExport.FileContentWrong'))
        } else {
          this.uploadSuccessUsage(response.data)
        }
      })
    },
    // excel导入 后数据处理 importFileHandler
    uploadSuccessUsage(data) {
      if (!data && !this.job) {
        this.$message.warning(this.$t('SeaExport.ImportFailedContactAdministrator'))
        return
      }
      const usageCompare = []
      for (const usage of this.job.containerUsages) {
        const oldContainer = usage.container
        for (const newUsage of data.containerUsages) {
          // 记录 已匹配的数据 如已参与比较不再 比对
          if (usageCompare.findIndex(p => p === newUsage) > -1) {
            continue
          }
          const newContainer = newUsage.container
          if (oldContainer.eqSize === newContainer.eqSize && oldContainer.eqType === newContainer.eqType) {
            oldContainer.containerNo = newContainer.containerNo
            oldContainer.sealNo = newContainer.sealNo
            oldContainer.containerWeight = newContainer.containerWeight
            oldContainer.remark = newContainer.remark
            oldContainer.cargoName = newContainer.cargoName
            oldContainer.isDirty = true
            oldContainer.boxController = newContainer.boxController
            oldContainer.carNumber = newContainer.carNumber
            oldContainer.weight = newContainer.weight

            usage.containerNo = newContainer.containerNo
            usage.containerWeight = newContainer.containerWeight
            usage.sealNo = newContainer.sealNo
            usage.remark = newContainer.remark
            usage.containerWeight = newContainer.containerWeight
            usage.cargoName = newContainer.cargoName

            usage.quantity = newUsage.quantity
            usage.weight = newUsage.weight
            usage.cubage = newUsage.cubage
            usage.hsCode = newUsage.hsCode
            usage.soc = newUsage.soc
            usage.isDirty = true
            usage.boxController = newContainer.boxController
            usage.carNumber = newContainer.carNumber

            usageCompare.push(newUsage)

            break
          }
        }
      }
      this.refreshTotal()
      if (this.gridApi) {
        this.gridApi.refreshCells({ force: true })
      }
    },
    // 组装打印参数
    getPrintData() {
      const containerUsages = this.gridApi.getSelectedRows()
      if (!containerUsages || containerUsages.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedContainerInformation'))
        return
      }
      const params = {}
      if (containerUsages.length === 1) {
        params.CONTAINER_UUID = containerUsages[0].container.uuid
        params.category = 'FCL'
        params.ctx = new IntegratedJob(this.job)
        // TemplateSelectorWin.getInstance().showThisWin(job, "FCL", params, this);
      } else {
        const uids = []
        for (const c of containerUsages) {
          if (c.container && c.container.uuid && !uids.includes(c.container.uuid)) {
            uids.push(c.container.uuid)
          }
        }
        params.CONTAINER_UUID = uids
        params.category = 'CONTAINER_LIST'
        params.ctx = new IntegratedJob(this.job)
        // TemplateSelectorWin.getInstance().showThisWin(job, "CONTAINER_LIST", params, this);
      }
      this.$logger.log('params', params)
      return params
    },
    onRowDragEnd(params) {
      console.log('dragEnd', params)
      params.api.getModel().rowsToDisplay.forEach(node => {
        console.log(node)
        node.data.serialNo = node.rowIndex
        this.onCellChange({ data: node.data, colDef: { colId: 'serialNo' }})
      })
    },
    // 初始处理港区数据
    initGoodsTmpInfo() {
      if (this.harbourList.length > 0) {
        this.harbourList.forEach(elements => {
          if (this.mergeHarbourList.length === 0) {
            this.mergeHarbourList.push(deepClone(elements))
          } else {
            let isIn = false
            this.mergeHarbourList.forEach(element => {
              if (element.containerNo === elements.containerNo && elements.containerNo && element.containerNo) {
                isIn = true
                if (!element.eqSize && elements.eqSize) {
                  element.eqSize = elements.eqSize
                }
                if (!element.eqType && elements.eqType) {
                  element.eqType = elements.eqType
                }
                if (!element.cargoEnglishName && elements.cargoEnglishName) {
                  element.cargoEnglishName = elements.cargoEnglishName
                }
                if (!element.hsCode && elements.hsCode) {
                  element.hsCode = elements.hsCode
                }
                if (!element.packing && elements.packing) {
                  element.packing = elements.packing
                }
                element.quantity = PortDataCompareUtils.adding(element.quantity, elements.quantity, true)
                element.weight = PortDataCompareUtils.adding(element.weight, elements.weight, false)
                element.cubage = PortDataCompareUtils.adding(element.cubage, elements.cubage, false)
                if (!element.soNo && elements.soNo) {
                  element.soNo = elements.soNo
                }
              }
            })
            if (!isIn) {
              this.mergeHarbourList.push(deepClone(elements))
            }
          }
        })
      }
    },
    // 初始化港区数据与当前装箱信息对比校验
    initCompare() {
      this.containerUsages.forEach(events => {
        const eve = events.container
        if (eve.confirmed === 0) {
          this.mergeHarbourList.forEach(event => {
            if (eve.containerNo === event.containerNo) { // 找到containerNo相同的数据
              if (event.confirmed === 0) {
                if (events.sealNo !== event.sealno ||
                  events.eqSize !== event.eqSize ||
                  events.eqType !== event.eqType ||
                  events.quantity !== event.quantity ||
                  events.weight !== event.weight ||
                  events.cubage !== event.cubage) {
                  events.confirmed = -1
                } else {
                  events.confirmed = 10
                  this.isAutoLoad = true
                }
              }
            }
          })
        }
        if (events.confirmed === 10 || events.confirmed === 11 || events.confirmed === 12 || events.confirmed === 13) {
          this.isAutoLoad = true
        }
      })

      const updateSystem = []
      this.containerUsages.forEach(eve => {
        if (!eve.confirmed) {
          eve.confirmed = eve.container.confirmed
        }
        if (eve.confirmed === 10) {
          updateSystem.push(eve)
        }
      })
      const result = []
      updateSystem.forEach(eve => {
        this.harbourList.forEach(elements => {
          if (eve.containerNo === elements.containerNo) {
            elements.confirmed = 10
            result.push({
              uuid: elements.uuid,
              confirmed: 10,
              jobUuid: this.job.jobUuid
            })
            this.isAutoLoad = true
          }
        })
      })
      this.$nextTick(() => {
        if (this.gridApi) {
          this.gridApi.refreshCells({ force: true })
        }
      })
    },
    // 数据对比弹框
    harbourCompare() {
      if (this.openPortDataService !== 4) {
        this.harbourWarnMessage()
        return
      }
      this.sourceList = [...this.harbourList]
      this.harbourDialog = true
      if (this.harbourCheckRead) {
        updateRead({ jobUuid: this.job.uuid }).then(() => {
          this.harbourCheckRead = false
        })
      }
    },
    // 同步港区数据
    harbourSync() {
      if (this.openPortDataService === 4) {
        this.$confirm(`<strong>【${this.$t('SeaExport.SynchronizePortData')}】${this.$t('SeaExport.TheOverwriteTheCurrentData')}</strong><br/><span style="color: red">${this.$t('SeaExport.ThisActionCannotBeUndone')}</span>，${this.$t('SeaExport.DoYouWantToContinue')}`, this.$t('Message.Prompt'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('Invoice.invoice_confirm'),
          cancelButtonText: this.$t('Message.Cancel'),
          type: 'warning'
        }).then(() => {
          if (this.harbourCheckRead) {
            updateRead({ jobUuid: this.job.uuid }).then(() => {
              this.harbourCheckRead = false
            })
          }
          this.syncData()
          // 同步港区后需要重新刷新装箱信息的件毛体合计
          this.refreshQWC()
        }).catch(() => {

        })
      } else {
        this.harbourWarnMessage()
      }
    },
    harbourWarnMessage() {
      let message = ''
      switch (this.openPortDataService) {
        case 1:
          message = this.$t('SeaExport.HarbourNotInServiceNoOpen') + '021-65143931。'
          break
        case 2:
          message = this.$t('SeaExport.HarbourInServiceNoOpen') + '021-65143931。'
          break
        case 3:
          message = this.$t('SeaExport.HarbourNotInServiceOpen')
          break
      }
      const h = this.$createElement
      this.$msgbox({
        message: h('div', { class: 'portData-service' }, [
          h('i', { class: 'el-icon-warning' }, ''),
          h('span', null, this.$t('Message.Prompt')),
          h('p', null, message)
        ]),
        showCancelButton: false,
        confirmButtonText: this.$t('Message.GotIt')
      }).then(() => {
      })
    },
    syncData() {
      this.isAutoLoad = false
      const harbourList = []
      this.harbourList.forEach(item => {
        item.confirmed = 10
      })
      const tempHarbour = deepClone(this.harbourList)
      this.selection = []
      this.containerUsages.forEach((element, keys) => {
        // 覆盖原货物信息
        element.poItems.forEach(item => {
          if (StrUtils.isEmpty(item.uuid)) {
            this.delPoItemsUuids.push(item.uuid)
          }
        })
        element.poItems = []
        delete element.type
        tempHarbour.forEach((eve, index) => {
          // 箱号不为空，且箱号相同的数据，或当前业务的箱号为空，港区的箱号不为空且箱型箱量相同的
          if ((!StrUtils.isEmpty(eve.containerNo) && (eve.containerNo === element.containerNo)) ||
            (StrUtils.isEmpty(element.containerNo) && eve.containerNo && element.eqSize === eve.eqSize && element.eqType === eve.eqType)) {
            element.containerNo = eve.containerNo
            element.sealNo = eve.sealno
            PortDataCompareUtils.syncPortDate(eve, element)
            PortDataCompareUtils.syncPortDate(eve, element.container)
            element.container.isDirty = true
            element.confirmed = 10
            const poItem = deepClone(eve)
            poItem.uuid = ''
            poItem.containerUsageKey = element.uuid
            poItem.grossWeight = eve.weight
            if (!element.poItems) {
              element.poItems = []
            }
            element.poItems.push(poItem)
            this.isAutoLoad = true
            this.selection.push({
              uuid: eve.uuid,
              confirmed: 10,
              jobUuid: this.job.jobUuid
            })
            harbourList.push(eve.uuid)
          }
        })
        PortDataCompareUtils.removeHarbourData(harbourList, tempHarbour)
      })
      // 箱号不一致 && 没有匹配的箱型箱种 && 港区数据 >= 当前数据
      const newUsages = {}
      tempHarbour.forEach((eve, index) => {
        eve.jobUuid = this.job.uuid
        PortDataCompareUtils.addNewContainerUsages(eve, newUsages)
        this.isAutoLoad = true
        this.selection.push({
          uuid: eve.uuid,
          confirmed: 10,
          jobUuid: this.job.jobUuid
        })
      })
      this.containerUsages.forEach((element, keys) => {
        let quantity = 0
        let weight = 0.000
        let cubage = 0.000
        if (element.poItems) {
          element.poItems.forEach(data => {
            quantity += data.quantity ? parseInt(data.quantity) : 0
            weight += data.grossWeight ? parseFloat(data.grossWeight) : 0
            cubage += data.cubage ? parseFloat(data.cubage) : 0
          })
        }
        element.container.containerNo = element.containerNo
        element.quantity = NumberUtils.formatNumber(quantity, 0)
        element.weight = NumberUtils.formatNumber(weight, 3)
        element.cubage = NumberUtils.formatNumber(cubage, 3)
      })
      for (const key in newUsages) {
        const item = newUsages[key]
        const container = item.container
        const containerUsage = item
        const seaEQ = item.seaEQ
        container.confirmed = 10
        container.containerUsage = []
        container.containerUsage.push(containerUsage)
        this.job.containers.push(container)
        PortDataCompareUtils.addSeaEQ(this.job.seaEQ, seaEQ.eqType, seaEQ.eqSize)
        item.confirmed = 10
        this.containerUsages.push(item)
      }
      if (this.gridApi) {
        this.gridApi.refreshCells({ force: true })
      }
      this.gridApi.clearFocusedCell()
    },
    handleAddContainer(newItem, selection) {
      this.isAutoLoad = false
      // 装箱件毛体 可能是从基本页签同步而来 没有触发cellChange 方法，同步箱子上的件毛体
      for (const usage of this.containerUsages) {
        if (usage.confirmed) {
          this.isAutoLoad = true
          usage.container.confirmed = usage.confirmed
        }
        usage.container.containerNo = usage.containerNo
        if (usage.type === '新增') {
          if (usage.container) {
            usage.container.quantity = usage.quantity
            usage.container.weight = usage.weight
            usage.container.cubage = usage.cubage
          }
          if (usage.poItems === '') {
            usage.poItems = []
          }
          // 处理从装箱信息数据对比新增的箱子
          if (StrUtils.isEmpty(usage.uuid)) {
            const container = usage.container
            const containerUsage = usage
            const seaEQ = usage.seaEQ
            container.containerUsage = []
            container.containerUsage.push(containerUsage)
            container.isDirty = true
            this.job.containers.push(container)
            PortDataCompareUtils.addSeaEQ(this.job.seaEQ, seaEQ.eqType, seaEQ.eqSize)
          }
        }
      }
      this.poItems = newItem
      this.selection = selection
      if (this.gridApi) {
        this.gridApi.clearFocusedCell()
        this.gridApi.refreshCells({ force: true })
      }
      this.$refs.portDataGoodsInfo.init({})
      this.initGoodsTmpInfo()
      // 数据对比后需要重新刷新装箱信息的件毛体合计
      this.refreshQWC()
    },
    handleChange(obj) {
      this.containerUsages.forEach(eve => {
        if ((!StrUtils.isEmpty(obj.uuid) && eve.uuid === obj.uuid) ||
          (StrUtils.isEmpty(obj.uuid) && eve.containerNo === obj.containerNo)) {
          eve.quantity = obj.quantity
          eve.weight = obj.weight
          eve.cubage = obj.cubage
        }
      })
      this.gridApi.setRowData(this.containerUsages)
      this.refreshQWC()
    },
    // 处理表格颜色
    containerPushDataStyleFunction(params, columnDataField) {
      if (params.data.confirmed > 0) {
        return { color: '' }
      }
      const warningClass = { color: '#f56c6c' }
      let result = false
      this.mergeHarbourList.forEach(eve => {
        if (eve.containerNo === params.data.containerNo) {
          result = params.data[columnDataField] !== eve[columnDataField]
        }
      })
      return result ? warningClass : { color: '' }
    },
    // 送仓时间、还空时间显示
    destinationDisplayFunction(params, field) {
      if (params.data && params.data.container) {
        const tempTime = params.data.container[field]
        return tempTime ? ColumnUtils.dateLabelFunc(tempTime) : ''
      }
      return ''
    },
    syncPoItemsContainerNo(usage) {
      if (usage.poItems && usage.poItems.length > 0) {
        for (const item of usage.poItems) {
          item.containerNo = usage.containerNo
        }
      }
    },
    // 抄录门点拖柜信息
    copyDoorPointData() {
      this.containerRecordDialog.visible = true
    },
    // 选择做柜信息
    selectTruckingRecordHandler(records) {
      this.containerUsages.forEach((element, keys) => {
        for (const record of records) {
          if (element.container.containerId === record.containerId) {
            element.container.containerNo = record.containerNo
            element.container.quantity = record.quantity
            element.container.weight = record.weight
            element.container.cubage = record.cubage
            element.container.containerWeight = record.containerWeight
            element.container.sealNo = record.sealNo
            element.container.plateNumber = record.truckNo

            element.containerNo = record.containerNo
            element.quantity = record.quantity
            element.weight = record.weight
            element.cubage = record.cubage
            element.containerWeight = record.containerWeight
            element.plateNumber = record.truckNo
            element.sealNo = record.sealNo
          }
        }
      })
      if (this.gridApi) {
        this.gridApi.clearFocusedCell()
        this.gridApi.refreshCells({ force: true })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.app-main-content {
  .operations {
    .triggers {
      overflow: visible;

      div {
        .el-badge {
          margin: 0 0 3px 5px;
        }
      }
    }
  }
}

.portData-service {
  padding-top: 10px;

  & > i {
    margin-right: 5px;
    color: #409EFF;
    font-size: 30px;
    vertical-align: middle;
  }

  & > span {
    line-height: 32px;
    vertical-align: middle;
    font-weight: bold;
    font-size: 16px;
    display: inline-block;
  }

  & > p {
    padding: 10px 0 10px 35px;
    line-height: 22px;
    font-size: 14px;
  }
}
</style>
